module.exports = __webpack_public_path__ + "static/media/de-flag.3e726c2b.svg";